import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { AtgardUtbyteBehaviour } from "./AtgardUtbyteBehaviour";

export class ArbetsorderUtbyteBehaviour {
    constructor(private readonly arbetsorder: IArbetsorderDetail) { }

    get direktUtbyteGrot(): number {
        return this.arbetsorder.atgarder
            .map(atgard => new AtgardUtbyteBehaviour(atgard))
            .reduce((total, atgard) => total + atgard.direktUtbyteGrot, 0);
    }

    get direktUtbyteRundvirke(): number {
        return this.arbetsorder.atgarder
            .map(atgard => new AtgardUtbyteBehaviour(atgard))
            .reduce((total, atgard) => total + atgard.direktUtbyteRundvirke, 0);
    }

    get simuleratUtbyteGrot(): number {
        const utbyteRundvirke = this.direktUtbyteRundvirke;
        const utbyteGrot = this.direktUtbyteGrot;

        if (!utbyteRundvirke) {
            return 0;
        }

        if (!utbyteGrot) {
            return 0;
        }

        const grotUtbytesandel = utbyteGrot / utbyteRundvirke;

        const simuleratUtbyteRundvirke = this.arbetsorder.handelssortiment
            .map(hs => hs.produkter)
            .reduce((a, b) => a.concat(b), [])
            .reduce((total, produkt) => total + produkt.kvantitet, 0);

        return Math.round(grotUtbytesandel * simuleratUtbyteRundvirke);
    }

    get simuleratUtbyteGrotV2(): number | undefined {
        const utbyteRundvirke = this.direktUtbyteRundvirke;
        const utbyteGrot = this.direktUtbyteGrot;

        if (!utbyteRundvirke) {
            return 0;
        }

        if (!utbyteGrot) {
            return 0;
        }

        const grotUtbytesandel = utbyteGrot / utbyteRundvirke;

        const simuleratUtbyteRundvirke: number | undefined = this.arbetsorder.handelssortiment
            .map(hs => hs.produkter)
            .reduce((a, b) => a.concat(b), [])
            .reduce((total, produkt) => {
                if (produkt.kvantitet === undefined) {
                    return total;
                }

                if (total === undefined) {
                    total = 0;
                }

                return total + produkt.kvantitet;
            }, undefined as number);

        if (simuleratUtbyteRundvirke === undefined) {
            return undefined;
        }

        return Math.round(grotUtbytesandel * simuleratUtbyteRundvirke);
    }
}
